module.exports = __webpack_public_path__ + "img/icon.fe8cfdb2.png";